
// Get all agents
export const getAgentsStart =()=>({
    type: "GET_AGENTS_START",
});
export const getAgentsSuccess =(agents)=>({
    type: "GET_AGENTS_SUCCESS",
    payload: agents,
});
export const getAgentsFailure =(error)=>({
    type: "GET_AGENTS_FAILURE",
    payload: error,
});


// Add one agent
export const addAgentStart =()=>({
    type: "ADD_AGENT_START",
});
export const addAgentSuccess =(agent)=>({
    type: "ADD_AGENT_SUCCESS",
    payload: agent,
});
export const addAgentFailure =(error)=>({
    type: "ADD_AGENT_FAILURE",
    payload: error,
});

// Update one agent
export const updateAgentStart =()=>({
    type: "UPDATE_AGENT_START",
});
export const updateAgentSuccess =(agent)=>({
    type: "UPDATE_AGENT_SUCCESS",
    payload: agent,
});
export const updateAgentFailure =(error)=>({
    type: "UPDATE_AGENT_FAILURE",
    payload: error,
});

// Activate one agent
export const activateAgentStart =()=>({
    type: "ACTIVATE_AGENT_START",
});
export const activateAgentSuccess =(agent)=>({
    type: "ACTIVATE_AGENT_SUCCESS",
    payload: agent,
});
export const activateAgentFailure =(error)=>({
    type: "ACTIVATE_AGENT_FAILURE",
    payload: error,
});